import { GET_USER_PASSPORT } from "../../../../enums/Profile/profile";

export const getUserPassportAction = (data) => {
    return {
        type: GET_USER_PASSPORT,
        payload: data,
    };
};
